import Budget from './Budget';

class BudgetSummary {
  public readonly availablePoint: number;
  public readonly usedPoint: number;
  public readonly budgets: Budget[];
  constructor({
    availablePoint,
    usedPoint,
    budgets,
  }: {
    availablePoint: number;
    usedPoint: number;
    budgets: Budget[];
  }) {
    this.availablePoint = availablePoint;
    this.usedPoint = usedPoint;
    this.budgets = budgets;
  }

  public static fromJSON = (value: any) => {
    const { available_point, used_point, details } = Object.assign({}, value);
    const availablePoint = available_point;
    const usedPoint = used_point;

    if (typeof availablePoint !== 'number') throw new TypeError('.availablePoint must be a number');
    if (typeof usedPoint !== 'number') throw new TypeError('.usedPoint must be a number');

    return new BudgetSummary({
      availablePoint,
      usedPoint,
      budgets: details.map((b: any) => Budget.fromJSON(b)),
    });
  };
}

export default BudgetSummary;
